import React from "react"
import { Tooltip } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faColumns,
  faSliders,
  faExpand,
  faCompress,
} from "@fortawesome/free-solid-svg-icons"
import MenuButton, { MenuButtonItem } from "shared/ui/MenuButton/MenuButton.component"
import { useDashboardLayoutStore } from "stores/dashboardLayoutStore"

/**
 * The dashboard's layout controls, as the console's: a "Layout ▾" menu that
 * shows or hides the variables rail and the inspector (each ticked while
 * shown), and the full-screen button on its own, since Esc leaves it again.
 */
const LayoutControls: React.FC = () => {
  const dataTreeVisible = useDashboardLayoutStore((s) => s.dataTreeVisible)
  const inspectorVisible = useDashboardLayoutStore((s) => s.inspectorVisible)
  const isMaximized = useDashboardLayoutStore((s) => s.isMaximized)
  const toggleDataTree = useDashboardLayoutStore((s) => s.toggleDataTree)
  const toggleInspector = useDashboardLayoutStore((s) => s.toggleInspector)
  const toggleMaximized = useDashboardLayoutStore((s) => s.toggleMaximized)

  const items: MenuButtonItem[] = [
    {
      key: "variables",
      label: "Variables panel",
      icon: <FontAwesomeIcon icon={faColumns} />,
      checked: dataTreeVisible,
      onClick: toggleDataTree,
    },
    {
      key: "inspector",
      label: "Inspector",
      icon: <FontAwesomeIcon icon={faSliders} />,
      checked: inspectorVisible,
      onClick: toggleInspector,
    },
  ]

  return (
    <>
      <MenuButton label="Layout" items={items} />
      <Tooltip
        title={isMaximized ? "Exit full screen (Esc)" : "Expand to full screen"}
        placement="bottom"
      >
        <button
          type="button"
          className="dq-btn dq-btn--icon"
          aria-label={isMaximized ? "Exit full screen" : "Enter full screen"}
          aria-pressed={isMaximized}
          data-active={isMaximized}
          onClick={toggleMaximized}
        >
          <FontAwesomeIcon icon={isMaximized ? faCompress : faExpand} />
        </button>
      </Tooltip>
    </>
  )
}

export default LayoutControls
